import {
    FormControl,
    FormControlLabel,
    Radio,
    RadioGroup,
    Stack,
    Typography,
} from '@mui/material';
import { useWarehouseLocationsSWR } from 'components/routes/Pages/Refund/hooks';
import RefundForm from 'components/routes/Pages/Refund/models/RefundForm';
import TextFieldControlled from 'components/shared/TextFieldControlled';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const PickupPoint: React.FC = () => {
    const { t } = useTranslation('refund', {
        keyPrefix: 'SHIPPING_DETAILS_STEP',
    });

    const form = useFormContext<RefundForm>();

    const { warehouseLocations, loading } = useWarehouseLocationsSWR();

    if (!warehouseLocations || loading) return null;

    return (
        <Stack gap={2} paddingX={1}>
            <Typography>{t('STORES')}</Typography>
            <Stack paddingX={1}>
                <FormControl>
                    <Controller
                        control={form.control}
                        name="pickup_point.store_location_id"
                        render={({ field }) => (
                            <RadioGroup
                                value={field.value}
                                onChange={(event) =>
                                    field.onChange(event.target.value)
                                }
                                defaultValue={warehouseLocations[0].id}
                            >
                                {warehouseLocations?.map((item, key) => (
                                    <FormControlLabel
                                        key={key}
                                        value={item.id}
                                        control={<Radio />}
                                        label={
                                            <Stack marginY={1}>
                                                <Typography
                                                    fontWeight="600"
                                                    textTransform="uppercase"
                                                >
                                                    {item.bc_location_name}
                                                </Typography>
                                                <Typography>
                                                    {item.address_data.postCode}{' '}
                                                    {item.address_data.city},{' '}
                                                    {item.address_data.address}{' '}
                                                    {item.address_data.address2}
                                                </Typography>
                                            </Stack>
                                        }
                                    />
                                ))}
                            </RadioGroup>
                        )}
                    />
                </FormControl>
            </Stack>

            <TextFieldControlled
                control={form.control}
                name="pickup_point.phone"
                label={t('PHONE')}
            />
        </Stack>
    );
};

export default PickupPoint;
